import { ComputeReservationDurationConfiguration, OwnerDefaultActionTypeEnum, ReservationActionTypesEnum } from '@api/ringil-api.v2';

export const defaultActionTypes = (settings: ComputeReservationDurationConfiguration | undefined, isOwner: boolean): ReservationActionTypesEnum[] => {
  const visible = isOwner ? settings?.ownerShowActionTypes : settings?.counterPartyShowActionTypes;
  if (visible !== true) return [];

  const defaultType: string | undefined = isOwner ? settings?.ownerDefaultActionType : settings?.counterPartyDefaultActionType;
  switch (defaultType) {
    case OwnerDefaultActionTypeEnum.LOADING:
      return [ReservationActionTypesEnum.LOADING];
    case OwnerDefaultActionTypeEnum.UNLOADING:
      return [ReservationActionTypesEnum.UNLOADING];
    case OwnerDefaultActionTypeEnum.BOTH:
      return [ReservationActionTypesEnum.LOADING, ReservationActionTypesEnum.UNLOADING];
    default:
      return [];
  }
};
